import * as config from '../config';

export default class JumpModel {
  constructor(step, jump) {
    this.step = step;
    this.jump = jump;
  }

  get id() {
    return this.jump.id;
  }

  get destinationStepId() {
    return this.jump.destination_step_id;
  }

  get label() {
    if (this.jump.options_ids) {
      return this.optionsLabel;
    }

    return config.STEP_JUMP_OTHER_LABEL;
  }

  get optionsLabel() {
    let label = '';

    this.jump.options_ids.forEach(optionId => {
      const option = this.step.options.find(element => element.id === optionId);
      label += `<label>${option.label}</label><br>`;
    });

    return label;
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/fluxogram/models/jump.js
 **/